import * as angular from 'angular';

(function () {
    'use strict';

    angular
        .module('app')
        .controller('HaIssueFormController', HaIssueFormController);

    /** @ngInject */
    function HaIssueFormController(
        $scope,
        $state,
        CustomFieldsService,
        HousingAssociationsFactory,
        HaEmployeeFactory,
        ngDialog,
        toastr
    ) {
        var vm = this;

        init();

        function init() {
            vm.save = save;
            vm.validationErrors = {};

            getCurrentClient();
        }

        function getCurrentClient() {
            HaEmployeeFactory.readMe().then(function (me) {
                vm.party_uuid = me.data.organization.party_uuid;
            });
        }

        function save() {
            if (vm.isUploaded) {
                HousingAssociationsFactory.addIssue(vm.party_uuid, {
                    additional_personal_data: vm.additionalPersonalData,
                    attachments: vm.documentsArray,
                    provider: vm.provider.party_uuid,
                    issue_category: vm.category,
                    description: vm.description,
                    locations: fillLocation(),
                    custom_fields: CustomFieldsService.parseCustomFields(
                        vm.customFields
                    ),
                }).then(
                    function () {
                        toastr.success('Zgłoszenie dodano.');
                        ngDialog.close();
                        $state.reload();
                    },
                    function (response) {
                        for (var key in response.data) {
                            var value = response.data[key];

                            if (
                                $scope.reportIssueForm &&
                                key != 'non_field_errors' &&
                                key != 'locations' &&
                                key != 'custom_fields'
                            ) {
                                $scope.reportIssueForm[key].$setValidity(
                                    'error_field',
                                    true
                                );
                            }

                            if (key === 'custom_fields') {
                                Object.keys(value).forEach(function(fieldId) {
                                    value[fieldId].forEach(function(element, index, array) {
                                        toastr.error(value[fieldId][index]);
                                    });
                                });
                            } else {
                                value.forEach(function(element, index, array) {
                                    toastr.error(value[index]);
                                });
                            }
                        }
                        vm.validationErrors = response.data.custom_fields;
                    }
                );
            } else {
                toastr.error('Musisz poczekać na wgranie pliku.');
            }
        }

        function fillLocation() {
            if (typeof vm.location === 'string') {
                return [{ short_address: vm.location }];
            }
        }
    }
})();



// WEBPACK FOOTER //
// ./node_modules/angularjs-template-loader??ref--0-1!./src/app/components/issues/issue_forms/ha_form/ha_issue_form.controller.ts